import React, { useContext } from "react";
import PropTypes from "prop-types";

import { useUniqueId } from "../hooks/useUniqueId";

import CheckboxGroup from "./CheckboxGroup";
import { CheckboxGroupContext } from "./CheckboxGroupContext";

import CheckboxLabel from "./CheckboxLabel";
import CheckboxLegend from "./CheckboxLegend";
import CheckboxWrapper from "./CheckboxWrapper";
import CheckboxInput from "./CheckboxInput";

export const Checkbox = (props) => {
  const {
    value,
    disabled,
    onlyDisplay,
    isValid,
    children,
    checked,
    onChange,
    checkboxProps,
    required,
    customClass,
    wrapperProps,
    ...restProps
  } = props;
  const { id } = restProps;
  const group = useContext(CheckboxGroupContext) || {};
  const checkboxId =
    id ||
    [
      "checkbox",
      group.id,
      group.checkboxIndex || useUniqueId("Checkbox", props) + 1,
    ]
      .filter((part) => part)
      .join("-");

  return (
    <CheckboxWrapper
      disabled={disabled}
      checkboxId={checkboxId}
      {...wrapperProps}
    >
      <CheckboxInput
        value={value}
        name={checkboxId}
        id={checkboxId}
        disabled={disabled || onlyDisplay}
        checked={checked}
        onChange={onChange}
        isValid={isValid}
        required={required}
        {...checkboxProps}
      />
      <CheckboxLabel id={checkboxId} {...restProps} customClass={customClass}>
        {children}
      </CheckboxLabel>
    </CheckboxWrapper>
  );
};

Checkbox.propTypes = {
  value: PropTypes.string,
  isValid: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onlyDisplay: PropTypes.bool,
  required: PropTypes.bool,
  customClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onChange: PropTypes.func,
  checkboxProps: PropTypes.shape({}),
  wrapperProps: PropTypes.shape({}),
};

Checkbox.defaultProps = {
  value: "",
  isValid: true,
  checked: false,
  disabled: false,
  onlyDisplay: false,
  required: false,
  customClass: undefined,
  onChange: null,
  checkboxProps: {},
  wrapperProps: {},
};

Checkbox.CheckboxGroup = CheckboxGroup;
Checkbox.CheckboxInput = CheckboxInput;
Checkbox.CheckboxLabel = CheckboxLabel;
Checkbox.CheckboxLegend = CheckboxLegend;
Checkbox.CheckboxWrapper = CheckboxWrapper;

Checkbox.displayName = "Checkbox";

export default Checkbox;
